import React, { useState } from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { Button, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import LoadingButton from '@mui/lab/LoadingButton';
import { createTeacherId } from '../database/createteacherId';
import { isTeacherId } from '../database/isTeacherId';
import { teacherIdState } from '../globalStates/general/teacherId';
import { useRecoilState } from 'recoil';
import AddOriginalSentence from './AddOriginalSentence';

const TeacherPage = () => {
  const [unSuccessful, setUnSuccessful] = useState(false);
  const [idCertification, setIdCertification] = useState(false);
  const [createIdDisplay, setCreateIdDisplay] = useState("none");
  const [createIdState, setCreateIdState] = useState("");
  const [createStatus, setCreateStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [teacherId, setTeacherId] = useRecoilState(teacherIdState);

  const closeStyle = css`
    margin-top: 100px;
  `;

  const inputPass = (e) => {
    isTeacherId(e.value).then((status) => {
      if (status) {
        setUnSuccessful(false);
        setIdCertification(true);
        setTeacherId(e.value);
      } else {
        setUnSuccessful(true);
        setIdCertification(false);
      }
    });
  }
  const createId = () => {
    setCreateIdDisplay("block");
  }
  const inputCreateId = async () => {
    if (window.confirm(String(createIdState).padStart(4, '0') + "作成しますか？")) {
      setCreateIdState(String(createIdState).padStart(4, '0'));
      setLoading(true);
      await createTeacherId(String(createIdState).padStart(4, '0')).then((status) => {
        setCreateStatus(status);
      });
      setLoading(false);
    }
  }
  const onChangeCreateId = (e) => {
    if (String(e.target.value).length > 4) {
      return;
    } else if (e.target.value < 0) {
      return;
    }
    setCreateIdState(e.target.value);
  }
  const teacherPageStyle = css`

    width: 100vw;
    height: 100vh;
 .window {
      position: relative;
      h3 {
        position: absolute;
        top: 80px;
        left: 50%;
        transform: translateX(-50%);
      }
      p {
        position: absolute;
        top: 300px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 0.7em;
      }
      button {
        cursor: pointer;
        position: absolute;
        border-radius: 2px;
        border: none;
        border-bottom: 0.5px solid #555;
        top: 430px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 0.7em;
      }
      color: #555;

      border-radius: 15px;
      margin: 150px auto;
      text-align: center;
      width: 500px;
      height: 500px;
      background-color: #e6e6e6b8;
      box-shadow:
        0 1.9px 2.5px rgba(0, 0, 0, 0.057),
        0 5px 6.1px rgba(0, 0, 0, 0.076),
        0 10.1px 11.4px rgba(0, 0, 0, 0.086),
        0 19.2px 19.8px rgba(0, 0, 0, 0.092),
        0 38.4px 34.8px rgba(0, 0, 0, 0.1),
        0 101px 74px rgba(0, 0, 0, 0.13);
    }
  `;
  const createIdWindowStyle = css`
    text-align: center;
    display: ${createIdDisplay};
    p.message {
      margin-top: 100px;
      font-size: 0.8em;
    }
    div.create-status {
      font-size: 0.8em;
      color: ${createStatus ? "green" : "red"};
    }
    h3 {
      text-align: center;
      margin-top: 90px;
      }
    color: #555;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -58.5%);
    border-radius: 15px;
    background-color: #e7e7e7;
    animation: bigger 1s ease forwards;
    z-index: 10;
    button {
      text-align: center;
    }
    @keyframes bigger {
      0% {
        width: 0;
        height: 0;
        opacity: 0;
      }
      100% {
        width: 600px;
        height: 600px;
        opacity: 1;
      }
    }
  `;
  return (
    <>
      <div css={createIdWindowStyle}>
        <h3>
          ID作成
        </h3>
        <p className='message'>先生の個人IDを生成します(数字4桁)</p>
        <div className='create-status'><p >{createStatus ? "🎉: 作成に成功しました!" : createStatus === "" ? "" : "😞: すでに使用されているIDです"}</p></div>
        <TextField id="outlined-basic" label="ID" variant="outlined" value={createIdState}
          type='number'
          onChange={(e) => {
            onChangeCreateId(e);
          }}
        />
        {
          loading ? (
            <LoadingButton
              endIcon={<SendIcon />}
              loading={loading}
              loadingPosition="center"
              variant="contained"
              sx={{ borderColor: 'gray', color: "#555", width: '55px', height: '55px', marginLeft: '15px', padding: '0 5px' }}
            >
            </LoadingButton>
          ) :
            (
              <Button variant="outlined" size="medium"
                sx={{ borderColor: 'gray', color: "#555", width: '55px', height: '55px', marginLeft: '15px', padding: '0 5px' }}
                onClick={() => {
                  inputCreateId();
                }}
              >
                送信
              </Button>
            )
        }
        <div css={closeStyle}>
          <Button variant="contained" sx={{ backgroundColor: "white", color: "#555", ":hover": { cursor: 'pointer', color: '#555', backgroundColor: "white" } }}
            onClick={() => setCreateIdDisplay("none")}>閉じる</Button>
        </div>

      </div>
      <div css={teacherPageStyle}>
        {
          // id 認証
          idCertification ? (
            <AddOriginalSentence teacherId={teacherId} />
          ) :
            (
              <div className='window'>
                <h3>ID認証</h3>
                <p>先生の個人IDを入力してください</p>
                <button
                  onClick={() => createId()}
                >IDを持っていない方はこちら</button>
                {
                  unSuccessful ? (
                    <TextField
                      error
                      id="outlined-error-helper-text"
                      label="Error"
                      helperText="Incorrect entry."
                      sx={{ marginTop: '250px' }}
                      onKeyDown={(e) => {
                        if (e.key = 'Enter') {
                          inputPass(e.target)
                        }
                      }}
                    />
                  ) : (
                    <TextField
                      id="filled-basic" label="ID" variant="filled"
                      sx={{ marginTop: '250px' }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          // エンターキー押下時の処理
                          inputPass(e.target);
                        }
                      }}
                    />
                  )
                }

              </div>
            )
        }
      </div>
    </>
  )
}

export default TeacherPage
